import { Link } from 'react-router-dom';
import { Download, ArrowLeft, Sparkles } from 'lucide-react';
import { OGEET_SET_MENU, OGEET_SET_MENU_PDF } from '../data/ogeetSetMenu';

export default function OGeetSetMenuPage() {
  return (
    <main data-testid="ogeet-set-menu" className="bg-[#1A0F08] text-[#FFF8E1] min-h-screen">
      {/* Hero */}
      <section className="relative pt-24 md:pt-32 pb-16 md:pb-20 px-6 text-center overflow-hidden">
        <div className="absolute -top-24 right-1/4 w-96 h-96 rounded-full bg-[#FF1493] opacity-25 blur-3xl pointer-events-none" />
        <div className="absolute -bottom-24 left-1/4 w-96 h-96 rounded-full bg-[#FFB300] opacity-20 blur-3xl pointer-events-none" />
        <div className="absolute top-1/3 left-1/2 w-72 h-72 rounded-full bg-[#6A1B9A] opacity-20 blur-3xl pointer-events-none" />
        <div className="relative max-w-3xl mx-auto">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="h-px w-12 bg-[#FFD54F]" />
            <span className="font-['Cormorant_Garamond'] italic text-[#FFD54F] text-sm tracking-[0.4em] uppercase">For a Limited Time</span>
            <span className="h-px w-12 bg-[#FFD54F]" />
          </div>
          <h1 className="font-['Marcellus'] text-4xl md:text-6xl text-[#FFF8E1] mb-4 leading-tight">
            Restaurant Week <span className="italic font-['Cormorant_Garamond'] text-[#FFD54F]">Set Menu</span>
          </h1>
          <p className="font-['Cormorant_Garamond'] italic text-lg md:text-xl text-[#FFF8E1]/80 max-w-xl mx-auto mb-8">
            Bold flavour, festival colour — three summer set menus, OGeet style.
          </p>
          <a
            href={OGEET_SET_MENU_PDF}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="ogeet-setmenu-download"
            className="group inline-flex items-center gap-3 bg-[#FFD54F] text-[#1C1917] px-8 py-4 font-['Cormorant_Garamond'] tracking-[0.25em] uppercase text-sm font-semibold rounded-full hover:bg-[#FFF8E1] transition-all duration-300 shadow-lg"
          >
            <Download size={17} /> Download PDF
          </a>
        </div>
      </section>

      {/* Menus */}
      <section className="max-w-6xl mx-auto px-6 pb-16 md:pb-24">
        <div className="grid md:grid-cols-3 gap-6">
          {OGEET_SET_MENU.map((menu, mi) => (
            <div
              key={menu.name}
              data-testid={`ogeet-setmenu-card-${mi}`}
              className="bg-[#2A140B] rounded-2xl border border-[#FFD54F]/20 hover:border-[#FF1493]/60 hover:-translate-y-1 transition-all duration-300 overflow-hidden flex flex-col shadow-[0_10px_40px_rgba(0,0,0,0.4)]"
            >
              <div className="px-6 py-6 text-center border-b border-[#FFD54F]/15 bg-gradient-to-b from-[#FF1493]/10 to-transparent">
                <div className="inline-flex items-center gap-2 text-[#FFD54F] mb-2">
                  <Sparkles size={15} />
                  <span className="font-['Cormorant_Garamond'] italic text-xs tracking-[0.3em] uppercase">{menu.courses}</span>
                </div>
                <h2 className="font-['Marcellus'] text-2xl text-[#FFF8E1]">{menu.name}</h2>
              </div>
              <div className="p-6 flex-1">
                <ul className="space-y-5">
                  {menu.items.map((item, ii) => (
                    <li key={ii} data-testid={`ogeet-setmenu-item-${mi}-${ii}`}>
                      <p className="font-['Cormorant_Garamond'] italic text-[11px] tracking-[0.3em] uppercase text-[#FFD54F] mb-1">{item.course}</p>
                      {item.dishes.map((d, di) => (
                        <div key={di}>
                          <p className="font-['Marcellus'] text-base md:text-lg text-[#FFF8E1] leading-snug">{d.name}</p>
                          {d.desc && <p className="font-['Cormorant_Garamond'] text-sm text-[#FFF8E1]/60 italic mt-0.5 leading-relaxed">{d.desc}</p>}
                        </div>
                      ))}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-14">
          <p className="font-['Cormorant_Garamond'] italic text-lg text-[#FFF8E1]/70 mb-6">Book your spot and mention "Restaurant Week".</p>
          <Link
            to="/ogeet#bookings"
            data-testid="ogeet-setmenu-reserve"
            className="inline-flex items-center gap-3 bg-[#FFD54F] text-[#1C1917] px-8 py-4 font-['Cormorant_Garamond'] tracking-[0.25em] uppercase text-sm font-semibold rounded-full hover:bg-[#FFF8E1] transition-all duration-300 shadow-lg"
          >
            Book a Table
          </Link>
          <div className="mt-8">
            <Link to="/ogeet" data-testid="ogeet-setmenu-back" className="inline-flex items-center gap-2 text-[#FFF8E1]/60 hover:text-[#FFD54F] font-['Cormorant_Garamond'] italic text-sm">
              <ArrowLeft size={15} /> Back to OGeet home
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
